import React, { useState, useRef, useEffect } from "react";
import "./DataAPIOperatorAgentChat.css"; // Import CSS for styles

const ChatInterface = () => {
  const [messages, setMessages] = useState([]); // Chat history
  const [input, setInput] = useState(""); // User input
  const [isVisible, setIsVisible] = useState(false); // Animation visibility
  const containerRef = useRef(null);
  const chatHistoryRef = useRef(null);

  useEffect(() => {
    // Animate on scroll
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  const handleSendMessage = async () => {
    if (!input.trim()) return;
  
    const userMessage = { role: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
  
    setTimeout(() => {
      if (chatHistoryRef.current) {
        chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
      }
    }, 100); // Delay ensures DOM updates first
  
    try {
      const response = await fetch("https://agentsserver.modlee.ai:5000/talk_to_wikipedia", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ input }),
      });
  
      if (!response.ok) throw new Error("Failed to fetch response");
  
      const data = await response.json();
      const botMessage = { role: "bot", text: data.response || "Error fetching response" };
  
      setMessages((prev) => [...prev, botMessage]);
  
      setTimeout(() => {
        if (chatHistoryRef.current) {
          chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
        }
      }, 100);
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [...prev, { role: "bot", text: "Something went wrong." }]);
    }
  
    setInput("");
  };
  

  return (
    <div
      className={`chat-interface-container ${isVisible ? "visible" : ""}`}
      ref={containerRef}
    >
      
      {/* Title */}
      <h2 className="chat-interface-title">Test Data Retrieval with Wikipedia</h2>

      {/* Description */}
      <p className="chat-interface-description">
        To demonstrate our agent's capability, we’ve showcased how seamlessly it interacts with Wikipedia’s API to provide high-fidelity, context-rich responses.
      </p>

      {/* Chat History */}
      <div className="chat-history" ref={chatHistoryRef}>

        {messages.map((msg, index) => (
          <div key={index} className={`chat-message ${msg.role}`}>
            <strong>{msg.role === "user" ? "You" : "AI"}:</strong> {msg.text}
          </div>
        ))}
      </div>

      {/* Input Section */}
      <div className="chat-input-container">
        <textarea
          className="chat-input"
          placeholder="Describe the information your want to retrieve ..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
        ></textarea>
        <button className="chat-send-button" onClick={handleSendMessage}>
          Send
        </button>
      </div>


    </div>
  );
};

export default ChatInterface;
